import { Route, UrlMatchResult, UrlSegment } from '@angular/router'

// Matches '' and a single ':section' segment
function landingSectionMatcher(url: UrlSegment[]): UrlMatchResult | null {
	if (url.length > 1) {
		return null
	}
	return { consumed: url, posParams: url.length ? { section: url[0] } : {} }
}

export const landingRoutes: Route[] = [
	{
		path: '',
		pathMatch: 'prefix',
		loadComponent: () => import('./landing/landing.layout').then((m) => m.LandingLayout),
		children: [
			{
				path: 'legal',
				pathMatch: 'prefix',
				loadChildren: () => import('@mos/client/web/legal/pages/legal.routes').then((m) => m.legalPublicRoutes),
			},
			{
				// A single route for '' and ':section' (e.g. '/login'): navigating between sections reuses the landing
				// content instead of destroying and recreating it (which replayed every enter animation)
				matcher: landingSectionMatcher,
				loadComponent: () =>
					import('./landing-content/landing-content.component').then((m) => m.LandingContentComponent),
			},
		],
	},
]
